export const ROLES = {
  CLIENT: "CLIENT",
  USER: "USER",
  ADMIN: "ADMIN",
  DEMO: "DEMO",
};
